import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

function withReactQueryClientProvider<P extends Record<any, any>>(
  WrappedComponent: React.ComponentType<P>
): React.FC<P> {
  return function WithReactQueryClientProvider(props: P) {
    const queryClient = new QueryClient({
      defaultOptions: {
        queries: {
          // https://tanstack.com/query/v4/docs/framework/react/reference/useQuery
          // Set conservatively low so that hydrated data is not considered immediately stale.
          staleTime: 300000, // 5 minutes
        },
      },
    })

    return (
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen={false} />
        <WrappedComponent queryClient={queryClient} {...(props as P)} />
      </QueryClientProvider>
    )
  }
}

export default withReactQueryClientProvider
